import { UserCentral } from "../models/userCentral";
import { login, refresh } from "../../infrastructure/api/authentication";
import { Ticket } from "../models/ticket";
import config from "./config";

export enum ACCESS_PERMISSION {
    ATS_User = "User"
}

export enum AUTH_STATUS {
    NONE,
    AUTHENTICATED,
    UNAUTHORIZED,
    ERROR
}

export let UserCentralContext: UserCentral | null = null;

/* eslint-disable */
export const UserManager = (function() {
  
    var casRedirect = function() {
        let returnUrl: string = window.location.href.replace("logout", "");
        window.location.href = config.CAS_URL + '/cas/login?service=' + returnUrl; 
        return null;
    };
  
    var loginAndGetToken = async function(casUrl: string) {
        let casTicket: Ticket = {
            CASTicket: casUrl    
        }
        let userSession: UserCentral = (await login(casTicket)) as UserCentral;
        // console.log(userSession);
        if (!userSession) {
            return AUTH_STATUS.ERROR;
        }
        window.sessionStorage.setItem('ATS_UserCentral', JSON.stringify(userSession));
        if(!checkToken()) {
            return AUTH_STATUS.ERROR;
        }
        return AUTH_STATUS.AUTHENTICATED; 
    };

    var getComputingId = function() {
        if (!checkToken() || !UserCentralContext) {
            return null;
        }
        return UserCentralContext.CASUser.ComputingId;
    }

    var logoutUser = function(casLogout: boolean = false) {
        UserCentralContext = null;
        window.sessionStorage.removeItem('ATS_UserCentral');
        if (casLogout) {
            window.location.href = config.CAS_URL + '/cas/logout'; 
            return null;
        }
    }

    var refreshToken = async function() {
        if (!UserCentralContext) {
            return AUTH_STATUS.ERROR;
        }
        let userSession: UserCentral = (await refresh(UserCentralContext)) as UserCentral;
        if (!userSession) {
            return AUTH_STATUS.ERROR;
        }
        UserCentralContext = userSession;
        window.sessionStorage.setItem('ATS_UserCentral', JSON.stringify(UserCentralContext));
        return AUTH_STATUS.AUTHENTICATED;
    };

    /*var validatePermission = function(accessNeeded: ACCESS_PERMISSION) {
        if (UserCentralContext && UserCentralContext?.UserCentralUser?.Permissions?.find((permission) => {
            return permission.PermissionName === accessNeeded;
          })) {
            return true;
        }
        return false;
    };*/

    var checkTokenAndRefresh = async function() {
        if (!UserCentralContext) {
            const userSession: string | null = window.sessionStorage.getItem("ATS_UserCentral");
            if (userSession) {
                UserCentralContext = JSON.parse(userSession);
            } else {
                return false;
            }
        }
        if (!UserCentralContext?.UserCentralToken?.TokenKey || !UserCentralContext?.UserCentralToken?.TokenExpire || new Date(UserCentralContext.UserCentralToken.TokenExpire).getTime() <= Date.now()) {
            return false;
        }
        let refreshTokenTime: number = Date.now() + (1*60*60*1000);
        if (new Date(UserCentralContext.UserCentralToken.TokenExpire).getTime() <= refreshTokenTime) {
            return (await refreshToken()) === AUTH_STATUS.AUTHENTICATED;
        }
        return true;
    };

    var checkToken = function() {
        if (!UserCentralContext) {
            const userSession: string | null = window.sessionStorage.getItem("ATS_UserCentral");
            if (userSession) {
                UserCentralContext = JSON.parse(userSession);
            } else {
                return false;
            }
        }
        if (!UserCentralContext?.UserCentralToken?.TokenKey || !UserCentralContext?.UserCentralToken?.TokenExpire || new Date(UserCentralContext.UserCentralToken.TokenExpire).getTime() <= Date.now()) {
            return false;
        }
        let refreshTokenTime: number = Date.now() + (1*60*60*1000);
        if (new Date(UserCentralContext.UserCentralToken.TokenExpire).getTime() <= refreshTokenTime) {
            return false;
        }
        return true;
    };
  
    return {
        logoutUser: logoutUser,
        loginAndGetToken: loginAndGetToken,
        getComputingId: getComputingId,
        casRedirect: casRedirect,
        refreshToken: refreshToken,
        // validatePermission: validatePermission,
        checkToken: checkToken,
        checkTokenAndRefresh: checkTokenAndRefresh
    }
  
  })();
  
  export default UserManager;
